<p-confirmDialog key="Main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="Auto" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="Finish" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Nav Bar-->
<div class="WholeTopBar">
	<h3 *ngIf="lstChangedData.length > 0" class="HelpText">* Data has been changed</h3>

	<div class="CalendarNavBar">
		<h4 class="FlexItem">Selected:</h4>
		<!-- <h4 class="FlexItem">{{SelectedMonth}} {{SelectedYear}}</h4>
    
        <h4 class="FlexItem">Go to:</h4> -->

		<!--Month-->
		<select class="form-control FlexItem SelectWidth" name="DisplayMonth" (ngModelChange)="onDisplayMonthChange($event)" [(ngModel)]="DisplayMonth">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstMonth" [ngValue]="o">{{ o }}</option>
		</select>

		<!--Year-->
		<select class="form-control FlexItem SelectWidth" name="DisplayYear" (ngModelChange)="onDisplayYearChange($event)" [(ngModel)]="DisplayYear">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstYear" [ngValue]="o">{{ o }}</option>
		</select>

		<!-- <button class="btn btn-primary FlexItem" (click)="onDisplay()">Display</button> -->
	</div>
</div>

<div class="TopMargin Buttons">
	<button class="btn btn-primary" [disabled]="DisablePrevious()" (click)="onPrevious()"><i class="fa fa-arrow-left"></i> Previous</button>
	<button class="btn btn-primary" [disabled]="DisableNext()" (click)="onNext()">Next <i class="fa fa-arrow-right"></i></button>
</div>

<!--Manually Created Calendar-->
<div class="TopMargin">
	<!--7 Col Grid for days-->
	<div class="DayGrid">
		<!--Headers-->
		<div class="TableHeader">
			<h4>Sunday</h4>
		</div>
		<div class="TableHeader">
			<h4>Monday</h4>
		</div>
		<div class="TableHeader">
			<h4>Tuesday</h4>
		</div>
		<div class="TableHeader">
			<h4>Wednesday</h4>
		</div>
		<div class="TableHeader">
			<h4>Thursday</h4>
		</div>
		<div class="TableHeader">
			<h4>Friday</h4>
		</div>
		<div class="TableHeader TableRight">
			<h4>Saturday</h4>
		</div>

		<!--Data-->
		<div
			[ngClass]="{
				TableData: true,
				Today: IsToday(o.DayNumber) == true,
				TableRight: (i + 1) % 7 == 0
			}"
			*ngFor="let o of Days; let i = index"
		>
			<caass-calendar-entry [DayNumber]="o.DayNumber" [IsOpen]="o.IsOpen" (DayChange)="onDayChange($event)"></caass-calendar-entry>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="TopMargin Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update Calendar</button>
	<button class="btn btn-primary" (click)="onReset()">Reset Calendar</button>
	<button class="btn btn-primary" (click)="onSelectAllWeekdays()">Select All Weekdays</button>
	<button class="btn btn-primary" (click)="onDeselectAllWeekdays()">Deselect All Weekdays</button>
</div>
